"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditorNumber = void 0;
const react_1 = __importStar(require("react"));
const components_1 = require("@apitable/components");
const core_1 = require("@apitable/core");
const ahooks_1 = require("ahooks");
const EditorNumber = (props) => {
    const { tooltip = (0, core_1.t)(core_1.Strings.number_cell_input_tips), validate, value, onChange, placeholder } = props;
    const [input, setInput] = (0, react_1.useState)(value);
    const [isFormat, setIsFormat] = (0, react_1.useState)(true);
    const { run: hideTipDebounce } = (0, ahooks_1.useDebounceFn)(() => setIsFormat(true), {
        wait: 2000,
    });
    const validateValue = (value) => {
        // allow null & undefined
        if (value == null) {
            return true;
        }
        const numV = Number(value);
        return !isNaN(numV);
    };
    const onInputChange = (e) => {
        const value = e.target.value;
        const validateRes = !validate || validateValue(value);
        if (!validateRes) {
            setIsFormat(validateRes);
            hideTipDebounce();
            return;
        }
        setInput(value);
        onChange && onChange(value || null);
    };
    return react_1.default.createElement(components_1.Tooltip, { visible: !isFormat, content: tooltip, placement: "top" },
        react_1.default.createElement(components_1.TextInput, { className: 'widgetFilterTextInput', style: { textAlign: 'right' }, block: true, value: input, onChange: onInputChange, placeholder: placeholder }));
};
exports.EditorNumber = EditorNumber;
